export default "__VITE_ASSET__C2O0bGWK__"